import { trackGoogle } from '@on3/ui-lib/utils/tracking';
import { useEffect } from 'react';

interface TrackingProps {
  event: string;
  data?: Record<string, any>;
  disable?: boolean;
  type?: 'google';
  children: React.ReactNode;
}

export const Tracking = ({
  event,
  data = {},
  disable = false,
  type = 'google',
  children,
}: TrackingProps) => {
  useEffect(() => {
    if (disable) return;

    if (type === 'google') {
      trackGoogle(event, data);
    }
  }, [event, data, type, disable]);

  return <>{children}</>;
};
